<wlm-file-upload
  [labelKey]="this.field.props?.label"
  [multiple]="this.field.props?.multiple"
  [formControl]="innerControl"
></wlm-file-upload>
